import React, {Component, useState} from "react";

import axios from "axios";
import { Box, Button, Column, Columns, Tabs } from "@allxsmith/bestax-bulma";
import VehicleRentalView from "./VehicleRentalView";
import ContactFilter from "../Invoicing/ContactFilter";
import {
  getFirstDayOfWeek,
  getLastDayOfWeek,
  getQueryString,
  formatDate, readableDate
} from "../../utils";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getDepartmentsData, getPartsData, getRentalsData} from "../../state/selectors";
import {usePartsData} from "../../hooks/usePartsData";
import {useRentalsData} from "../../hooks/useRentalsData";
import useSelect from "../../hooks/useSelect";
import Spinner from "react-spinner-material";
import useWeekInput from "../../hooks/useWeekInput";
import {InsuranceView} from "./InsuranceView";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import DepartmentPicker from "../Job/DepartmentPicker";
import DepositRefundSection from "./DepositRefundSection";
import {createSetDataFreshAction, createSetRentalsDataAction} from "../../actions/dataActions";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import BlankDepartmentSelector from "../Utils/BlankDepartmentSelector";
import InfoModal from "./InfoModal";
import Figure from "../Utils/Figure";
import VehicleView from "./Vehicles/View";
import FigureSummary from "../Figures/FigureSummary";
import Nav from "../Nav/Nav";
import LoadingSpinner from "../Utils/Spinner";
import {toast} from "react-toastify";

export default function View(props) {
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [currentSearch, setCurrentSearch] = useState("");
  const [filters, setFilters] = useState({});
  const [selectedDepartment, setSelectedDepartment] = useState("BLANK");
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const dispatch = useDispatch();
  const dataFresh = useSelector(getDataFresh);

  const [view, setView] = useState("onhires");
  // const [view, viewInput] = useSelect({
  //   label: "View",
  //   options: [
  //     {name: "All", value: "all"},
  //     {name: "Weekly", value: "weekly"},
  //     {name: "Upcoming Onhires", value: "onhires"},
  //     {name: "All On Hire", value: "all_hire"},
  //     {name: "Upcoming Offhires", value: "offhires"},
  //     {name: "Insurance Expiries", value: "insurance"},
  //     {name: "Unfinished Offhires", value: "unfinished_off"},
  //     {name: "Quotes", value: "quotes"},
  //     {name: "Not Required", value: "nr"},
  //   ],
  //   initialValue: "onhires",
  //   callback: () => {
  //     setPage(1);
  //   }
  // });

  const [trackerView, trackerViewInput] = useSelect({
    label: "Tracker Hire",
    options: [
      {name: "No", value: "false"},
      {name: "Yes", value: "true"}
    ],
    initialValue: "false",
    callback: () => {
      setPage(1);
    }
  });

  const [day, dayInput] = useWeekInput({
    label: "Day",
    initialValue: new Date(),
    callback: () => {
      setPage(1);
    }
  });

  const onDepartmentChange = e => {
    setSelectedDepartment(e.target.value);
  }

  const onPayed = (rental) => {
      // Takes a rental and marks the deposit as refunded
      const conf = {
          url: props.endpoint + "depositpayed",
          method: "put",
          data: rental
      }
      axios(conf).then(res => {
          dispatch(createSetDataFreshAction(dataFresh + 1));
      }).catch(err => {
          toast.error("There was an error marking that deposit as refunded");
      })
  }


  const firstDayOfWeek = getFirstDayOfWeek(day);
  const lastDayOfWeek = getLastDayOfWeek(firstDayOfWeek);

  const dateRangeString = ` - Monday ${readableDate(formatDate(firstDayOfWeek))} - Sunday ${readableDate(formatDate(lastDayOfWeek))}`;
  let params = {page, day, view, tracker: trackerView}
    for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }
  if(selectedDepartment){
    params.department = selectedDepartment
  }

  const getMissingOffHireItems = (rental) => {
        let str = "";
        if(rental.has_damage === "UNKNOWN"){
            str = str.concat(" ", "DAMAGE");
        }
        if(rental.missing_fuel && (rental.off_hire_missing_fuel <= 0)){
            str = str.concat(" ", "FUEL");
        }
        if(rental.missing_ad_blue && (rental.off_hire_ad_blue_charge <= 0)){
            str = str.concat(" ", "ADBUE")
        }

        return str
  }

  const triggerChange = (e, dataArray, index) => {
      // dataArray is the data source as the rentals list end point returns multiple sets of data
      let newData = {...data}
      let newDataArray = [...newData[dataArray]];
      let newItem = {...newDataArray[index]};

      newItem[e.target.name] = e.target.value;
      newDataArray[index] = newItem;


      newData[dataArray] = [];
      dispatch(createSetRentalsDataAction(newData));
  }


  const onSave = (rental) => {
      const conf = {
          method: "post",
          data: rental,
          url: props.endpoint+`rentals/${rental.id}`
      }
      axios(conf).then(res => {
          dispatch(createSetRentalsDataAction(dataFresh + 1))
      }).catch(err => {
          toast.error("There was an error saving", {position: "top-right"})
      })
  }

  const onViewChange = (value) => {
      setPage(1);
      setView(value);
  }

  const complete = useRentalsData(params, dataFresh);
  const departmentsLoaded = useDepartmentsData({}, dataFresh);
  const data = useSelector(getRentalsData);

  const departments = useSelector(getDepartmentsData);

  if (!complete || !departmentsLoaded) {
    return (
      <div>
          <Nav/>
          <LoadingSpinner/>
      </div>
    );
  }
  document.title = "Rentals";
  return (
    <div>
      <Nav/>
      {/*<VehicleView/>*/}
      <br/>
      <br/>
      <Box>
        <Button
          color="success"
          onClick={() => window.open("/editrental", "_self")}
          isFullWidth
        >
          New Rental +
        </Button>
      </Box>
      <Box>
        <Tabs fullwidth align="centered" toggle>
          <Tabs.List>
            {/*{viewInput}*/}
            {/*{view === 'weekly' && dayInput}*/}
            {trackerViewInput}
            <Column>
              <BlankDepartmentSelector
                  selectedDepartment={selectedDepartment}
                  departments={departments}
                  onDepartmentChange={onDepartmentChange}
              />
            </Column>
            <Column>
                <Button
                  color={"info"}
                  onClick={() => setInfoModalOpen(true)}
                >
                    Info
                </Button>
            </Column>
          </Tabs.List>
        </Tabs>
        {!!view && (
          <div>
          </div>
        )}
      </Box>
      <Box>
          <Columns isMultiline>
              <Figure
                loaded={data.all_hire > -1}
                label={"All On Hire"}
                value={data.all_hire}
              />
              <Figure
                loaded={data.onhires > -1}
                label={"Upcoming Onhires"}
                value={data.onhires}
              />
              <Figure
                loaded={data.offhires > -1}
                label={"Upcoming Offhires"}
                value={data.offhires}
              />
              <Figure
                loaded={data.insurance > -1}
                label={"Insurance Expiries"}
                value={data.insurance}
              />
              <Figure
                loaded={data.unfinished_off > -1}
                label={"Unfinished Offhires"}
                value={data.unfinished_off}
              />
              <Figure
                loaded={data.awaiting_quote > -1}
                label={"Awaiting Quotes"}
                value={data.awaiting_quote}
              />
          </Columns>
      </Box>
      <FigureSummary selectedDepartment={selectedDepartment}/>
      <DepositRefundSection data={data} onPayed={onPayed} getMissingOffHireItems={getMissingOffHireItems} triggerChange={triggerChange} onSave={onSave}/>
      {(view === 'all' || view === "weekly" || view === 'quotes' || view === 'nr' || view === 'onhires' ||
              view === 'offhires' || view === 'unfinished_off' || view === "over_mileage"
              || view === "all_hire" || "awaiting_quote") &&
       <VehicleRentalView
        rentals={data}
        total_long_term={data.total_long_term}
        total_short_term={data.total_short_term}
        current={page}
        count={data.count}
        filters={filters}
        dateRangeString={view == 'weekly' && dateRangeString}
        setFilters={setFilters}
        filterList={data.filter_list}
        onPageChange={setPage}
        view={view}
        onViewChange={onViewChange}
        dataFresh={dataFresh}
        getMissingOffHireItems={getMissingOffHireItems}
        day={day}
        dayInput={dayInput}
      />}
      {view === 'insurance' && <InsuranceView
        rentals={data.results}
        current={page}
        count={data.count}
        onPageChange={setPage}
        view={view}
        onViewChange={onViewChange}
        total_long_term={data.total_long_term}
        total_short_term={data.total_short_term}
        />
        }
      <InfoModal
        show={infoModalOpen}
        setShow={setInfoModalOpen}
      />
    </div>
  );
}

